// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3Y-_a","name":"ConsentHeader_name__3vMzM","birthday":"ConsentHeader_birthday__2n7Xr","skeleton":"ConsentHeader_skeleton__3xbir"};